import { render, staticRenderFns } from "./UserManagementDropdown.vue?vue&type=template&id=34938c78&scoped=true"
import script from "./UserManagementDropdown.vue?vue&type=script&lang=js"
export * from "./UserManagementDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34938c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34938c78')) {
      api.createRecord('34938c78', component.options)
    } else {
      api.reload('34938c78', component.options)
    }
    module.hot.accept("./UserManagementDropdown.vue?vue&type=template&id=34938c78&scoped=true", function () {
      api.rerender('34938c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/teams/UserManagementDropdown.vue"
export default component.exports